(ns frontend.view.named-view.events
  (:require [common.localization :as loc]
            [frontend.actions.named-view :as named-view-actions]
            [frontend.logging :as logging]
            [frontend.view.modals.events :as modals]
            [frontend.view.modals.confirmation.view :as confirmation]
            [frontend.actions.entity :as entity-actions]
            [frontend.view.error-utils :as error-utils]))

(defn delete-view! [named-view]
  (entity-actions/*->disable! (:db/id named-view)
                              identity
                              error-utils/show-error!))

(defn start-delete-view! [named-view-id]
  (modals/open-modal!
   confirmation/modal-key
   {:body           (loc/tr :confirm-delete-named-view)
    :confirm-text   (loc/tr :delete)
    :confirm-icon   ""
    :skip-checkbox? true
    :on-confirm     (fn [& args]
                      (delete-view! {:db/id named-view-id}))}))
